"use client";
import React, { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import ProductCard from "../Cards/ProductCard";
import wwd1 from "../../../public/assets/beer-bottle-amber.jpg";
import wwd2 from "../../../public/assets/beer-bottle-green.jpg";
import wwd3 from "../../../public/assets/food-jar.jpg";
import wwd4 from "../../../public/assets/liquor-bottles.jpg";
import wwd5 from "../../../public/assets/pharma-products.jpg";
import wwd6 from "../../../public/assets/sheet-glass.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const products = [
  {
    id: 1,
    href: "/beer-bottle",
    title: "Beer Bottle - Amber",
    image: wwd1,
  },
  {
    id: 2,
    href: "/beer-bottle",
    title: "Beer Bottle - Green",
    image: wwd2,
  },
  {
    id: 3,
    href: "/food-jar",
    title: "Food Jar",
    image: wwd3,
  },
  {
    id: 4,
    href: "/liquor-bottle",
    title: "Liquor Bottles",
    image: wwd4,
  },
  {
    id: 5,
    href: "/pharma-bottle",
    title: "Pharma Products",
    image: wwd5,
  },
  {
    id: 6,
    href: "/sheet-glass",
    title: "Sheet Glass",
    image: wwd6,
  },
];

const ProductSecMobile = () => {
  const sliderRef = useRef<Slider>(null);
  const [isReady, setIsReady] = useState(false);

  // Force slick to update after mount and on resize
  useEffect(() => {
    const updateSlider = () => {
      sliderRef.current?.slickGoTo(0);
    };

    // Delay to ensure smooth scroll (like Lenis/Locomotive) is initialized
    const timeout = setTimeout(() => {
      updateSlider();
      setIsReady(true);
    }, 300); // Adjust delay if needed

    window.addEventListener("resize", updateSlider);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", updateSlider);
    };
  }, []);

  const settings: Settings = {
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="xl:pt-[80px] xl:pb-[50px] py-[50px] overflow-x-hidden px-4 md:px-0 relative bg-gradient-to-b from-white to-[#fbf9f5] block xl:hidden">
      <div className="">
        <h2 className="title !text-center !mb-5 !text-[#033b6f]">
          What <span className="text-[#d42427]"> We</span> Do
        </h2>

        {isReady && (
          <Slider ref={sliderRef} {...settings}>
            {products.map((product, index) => (
              <div
                key={index}
                className="px-3 transition-transform duration-500"
              >
                <div className="product-grid ">
                  <ProductCard {...product} />
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </section>
  );
};

export default ProductSecMobile;
